(function () {
  if (window.__sadarBundleScriptLoaded) {
    if (typeof window.__sadarBundleInitAll === 'function') window.__sadarBundleInitAll(document);
    return;
  }
  window.__sadarBundleScriptLoaded = true;

  function initBundle(root) {
    const sectionId = root.dataset.sectionId;
    window.__sadarBundleInstances = window.__sadarBundleInstances || {};
    const previousInstance = window.__sadarBundleInstances[sectionId];
    if (previousInstance && previousInstance.root === root) return;
    if (previousInstance) {
      previousInstance.controller.abort();
      previousInstance.root.remove();
    }

    const controller = new AbortController();
    const on = (target, type, listener, options) => {
      if (!target) return;
      target.addEventListener(type, listener, { ...(options || {}), signal: controller.signal });
    };
    window.__sadarBundleInstances[sectionId] = { root, controller };
    root.dataset.sadarReady = 'true';
    if (root.parentElement !== document.body) document.body.appendChild(root);

    const productFormId = root.dataset.productFormId;
    const currency = root.dataset.currency;
    const cartUrl = window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart' : '/cart';
    const groups = Array.from(root.querySelectorAll('[data-bundle-group]'));
    const dialog = root.querySelector('[role="dialog"]');
    const closeButtons = Array.from(root.querySelectorAll('.js-sadar-close'));
    const skipButton = root.querySelector('.js-sadar-skip');
    const copy = {};
    let lastFocusedElement = null;
    let lockedScrollPosition = 0;
    let pendingOpen = false;
    let pendingTimer = null;

    const copyTemplate = root.querySelector('.js-sadar-copy');
    const copyRoot = copyTemplate && copyTemplate.content ? copyTemplate.content : copyTemplate;
    if (copyRoot) copyRoot.querySelectorAll('[data-key]').forEach((item) => {
      copy[item.dataset.key] = item.textContent.trim();
    });

    let mainVariants = [];
    try {
      mainVariants = JSON.parse(root.querySelector('.js-sadar-main-variants').textContent);
    } catch (error) {
      mainVariants = [];
    }

    const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'sk-SK', {
      style: 'currency',
      currency
    }).format(cents / 100);

    const showMiniCart = () => {
      window.__sadarBundleFlowActive = false;
      try {
        const miniCart = window.Alpine && Alpine.store('xMiniCart');
        if (miniCart && typeof miniCart.openCart === 'function') {
          miniCart.openCart();
          setTimeout(() => {
            if (window.location.pathname === '/cart' || miniCart.open) return;
            miniCart.open = true;
            const popup = Alpine.store('xPopup');
            if (popup) popup.open = true;
          }, 120);
          const count = document.querySelector('#cart-icon-bubble span');
          if (count && Alpine.store('xCartHelper')) Alpine.store('xCartHelper').currentItemCount = Number(count.textContent);
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          return;
        }

        window.location.assign(cartUrl);
      } catch (error) {
        window.location.assign(cartUrl);
      }
    };

    const focusableElements = () => Array.from(dialog.querySelectorAll(
      'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter((element) => !element.hidden && element.offsetParent !== null);

    const openModal = () => {
      if (!root.hidden) return;
      lastFocusedElement = document.activeElement;
      lockedScrollPosition = window.scrollY;
      root.hidden = false;
      document.documentElement.classList.add('sadar-bundle-modal-open');
      document.body.classList.add('sadar-bundle-modal-open');
      document.body.style.setProperty('--sadar-page-offset', `-${lockedScrollPosition}px`);
      update();
      requestAnimationFrame(() => {
        const closeButton = root.querySelector('.sadar-bundle__close');
        if (closeButton) closeButton.focus();
      });
    };

    const closeModal = (restoreFocus = true) => {
      if (root.hidden) return;
      root.hidden = true;
      document.documentElement.classList.remove('sadar-bundle-modal-open');
      document.body.classList.remove('sadar-bundle-modal-open');
      document.body.style.removeProperty('--sadar-page-offset');
      window.scrollTo(0, lockedScrollPosition);
      if (restoreFocus && lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    };

    const getMainVariant = () => {
      const variantInput = document.querySelector(`#${CSS.escape(productFormId)} [name="id"]`) || document.getElementById(`update-variant-${sectionId}`);
      const variantId = Number(variantInput && variantInput.value);
      return mainVariants.find((variant) => Number(variant.id) === variantId) || mainVariants[0];
    };

    const getMainQuantity = () => {
      const quantityInput = document.querySelector(`#Quantity-${CSS.escape(sectionId)}`) || document.querySelector(`#${CSS.escape(productFormId)} [name="quantity"]`);
      return Math.max(1, Number(quantityInput && quantityInput.value) || 1);
    };

    const selectedOption = (group) => {
      if (group.dataset.bundleGroup === 'stake') {
        const selectedStake = group.querySelector('input[type="radio"]:checked');
        return selectedStake ? group.querySelector(`.js-sadar-variant[data-stake-type="${selectedStake.value}"] option:checked`) : null;
      }
      return group.querySelector('.js-sadar-variant option:checked');
    };

    const isSelected = (group) => {
      const toggle = group.querySelector('.js-sadar-group-toggle');
      return Boolean(toggle && toggle.checked && !toggle.disabled && selectedOption(group));
    };

    const availableGroups = () => groups.filter((group) => !group.querySelector('.js-sadar-group-toggle').disabled);

    const update = () => {
      const mainQuantity = getMainQuantity();
      const selectable = availableGroups();
      const selected = selectable.filter(isSelected);
      const complete = selectable.length > 0 && selected.length === selectable.length;
      let total = 0;

      groups.forEach((group) => {
        const active = isSelected(group);
        const option = selectedOption(group);
        const quantity = Number(root.dataset[`${group.dataset.bundleGroup}Quantity`]) || 1;
        const price = option ? Number(option.dataset.price) * quantity * mainQuantity : 0;
        group.classList.toggle('is-selected', active);
        const unitPrice = option ? Number(option.dataset.price) * quantity : 0;
        const itemPrice = group.querySelector('.js-sadar-item-price-value');
        if (itemPrice && option) itemPrice.textContent = formatMoney(unitPrice);
        if (active) total += price;
      });

      root.querySelector('.js-sadar-summary-label').textContent = complete ? copy.complete_price : copy.selected_price;
      root.querySelector('.js-sadar-total').textContent = formatMoney(total);
      root.querySelector('.js-sadar-button-label').textContent = complete ? copy.add_complete : copy.add_selected;
      root.dataset.complete = complete ? 'true' : 'false';
      root.dataset.selectedCount = String(selected.length);
      const button = root.querySelector('.js-sadar-add');
      if (button && !button.classList.contains('is-loading')) button.disabled = selected.length === 0;
    };

    const sectionsToRender = () => {
      try {
        return window.Alpine && Alpine.store('xCartHelper')
          ? Alpine.store('xCartHelper').getSectionsToRender()
          : [];
      } catch (error) {
        return [];
      }
    };

    const renderCart = (response, sections) => {
      if (!response.sections) return;
      sections.forEach((section) => {
        const element = document.querySelector(section.selector);
        const sectionMarkup = response.sections[section.id];
        if (!element || !sectionMarkup) return;

        if (typeof getSectionInnerHTML === 'function') {
          element.innerHTML = getSectionInnerHTML(sectionMarkup, section.selector);
          return;
        }

        const parsedSection = new DOMParser().parseFromString(sectionMarkup, 'text/html');
        const parsedElement = parsedSection.querySelector(section.selector);
        element.innerHTML = parsedElement ? parsedElement.innerHTML : sectionMarkup;
      });
    };

    const refreshCart = async (sections) => {
      try {
        const sectionIds = [...new Set(sections.map((section) => section.id))].join(',');
        if (!sectionIds) throw new Error('Missing cart sections');
        const response = await fetch(`${window.location.pathname}?sections=${encodeURIComponent(sectionIds)}`, {
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Unable to refresh cart');
        const renderedSections = await response.json();
        renderCart({ sections: renderedSections }, sections);
      } catch (error) {
        try {
          const miniCart = window.Alpine && Alpine.store('xMiniCart');
          if (miniCart && typeof miniCart.reLoad === 'function') miniCart.reLoad();
        } catch (reloadError) {
          return;
        }
      }
    };

    const addButton = root.querySelector('.js-sadar-add');
    on(addButton, 'click', async () => {
      const errorElement = root.querySelector('.js-sadar-error');
      const mainVariant = getMainVariant();
      if (!mainVariant) {
        errorElement.textContent = copy.error;
        errorElement.hidden = false;
        return;
      }

      const mainQuantity = getMainQuantity();
      const complete = root.dataset.complete === 'true';
      const bundleId = `sadar-${Date.now()}`;
      const properties = {
        _sadar_bundle: bundleId,
        _sadar_bundle_complete: complete ? 'true' : 'false'
      };
      const items = [];

      groups.filter(isSelected).forEach((group) => {
        const option = selectedOption(group);
        const quantity = Number(root.dataset[`${group.dataset.bundleGroup}Quantity`]) || 1;
        items.push({ id: Number(option.value), quantity: quantity * mainQuantity, properties });
      });

      if (items.length === 0) return;

      const sections = sectionsToRender();
      addButton.disabled = true;
      addButton.classList.add('is-loading');
      root.querySelector('.js-sadar-button-label').textContent = copy.adding;
      errorElement.hidden = true;

      try {
        const addResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items, sections: sections.map((section) => section.id) })
        });
        const added = await addResponse.json();
        if (!addResponse.ok || added.status === 422) throw new Error(added.description || copy.error);
        renderCart(added, sections);
        await refreshCart(sections);
        closeModal(false);
        showMiniCart();
      } catch (error) {
        errorElement.textContent = error.message || copy.error;
        errorElement.hidden = false;
      } finally {
        addButton.classList.remove('is-loading');
        addButton.disabled = false;
        update();
      }
    });

    const finishWithoutExtras = () => {
      closeModal(false);
      showMiniCart();
    };

    closeButtons.forEach((button) => on(button, 'click', finishWithoutExtras));
    if (skipButton) {
      on(skipButton, 'click', finishWithoutExtras);
    }

    on(dialog, 'keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        finishWithoutExtras();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = focusableElements();
      if (focusable.length === 0) {
        event.preventDefault();
        dialog.focus();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    const mainAddButton = document.getElementById(`x-atc-button-${sectionId}`);
    if (mainAddButton) {
      on(mainAddButton, 'click', () => {
        if (mainAddButton.disabled || mainAddButton.dataset.available === 'false') return;
        pendingOpen = true;
        window.__sadarBundleFlowActive = true;
        clearTimeout(pendingTimer);
        pendingTimer = setTimeout(() => {
          pendingOpen = false;
          window.__sadarBundleFlowActive = false;
        }, 15000);
      });
    }
    on(document, 'eurus:cart:items-changed', () => {
      if (!pendingOpen) return;
      pendingOpen = false;
      clearTimeout(pendingTimer);
      openModal();
    });

    on(root, 'change', update);
    const quantityInput = document.getElementById(`Quantity-${sectionId}`);
    if (quantityInput) {
      on(quantityInput, 'input', update);
      on(quantityInput, 'change', update);
      const quantityControls = quantityInput.parentElement;
      if (quantityControls) {
        on(quantityControls, 'click', () => requestAnimationFrame(update));
      }
    }
    on(document, `eurus:product-page-variant-select:updated:${sectionId}`, update);
    update();

    const previewMode = new URLSearchParams(window.location.search).get('sadar_preview');
    const isThemePreview = Boolean(
      (window.Shopify && Shopify.designMode)
      || (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main')
      || window.location.hostname.endsWith('.shopifypreview.com')
    );
    if (isThemePreview && previewMode === root.dataset.bundleMode) {
      const successLabel = root.querySelector('.js-sadar-success-label');
      if (successLabel && root.dataset.previewLabel) successLabel.textContent = root.dataset.previewLabel;
      requestAnimationFrame(openModal);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sadar-bundle]').forEach(initBundle);
  }

  window.__sadarBundleInitAll = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const sectionId = event.detail && event.detail.sectionId;
    const instance = sectionId && window.__sadarBundleInstances && window.__sadarBundleInstances[sectionId];
    if (!instance) return;
    instance.controller.abort();
    instance.root.remove();
    delete window.__sadarBundleInstances[sectionId];
  });
})();
